import { Flex } from 'shared_DEPRECATED/components/Flex';
import EmojiPicker from 'shared_DEPRECATED/components/Form/EmojiPicker';
import {
  ReactionsCommon,
  ReactionsPopoverButton,
} from 'shared_DEPRECATED/components/Reactions';
import { DEFAULT_REACTIONS } from 'shared_DEPRECATED/components/Reactions/config';
import useMultipleToggle from 'shared_DEPRECATED/hooks/useMultipleToggle';

import { useColorMode } from 'shared/components/ColorMode/useColorMode';
import {
  PopoverRoot,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from 'shared/components/Popover/Popover';

const PICKER = {
  SMALL: 'smallPicker',
  BIG: 'bigPicker',
};

type TReactionEmojiPicker = {
  handleEmojiSelect: (emoji: string) => void;
  options?: any;
  emojis?: string[];
  theme?: 'light' | 'dark';
};

export const ReactionEmojiPicker = ({
  emojis = DEFAULT_REACTIONS,
  handleEmojiSelect,
  options,
  theme,
}: TReactionEmojiPicker) => {
  const { state, toggleOpen, toggleAll } = useMultipleToggle({
    toggleNames: [PICKER.SMALL, PICKER.BIG],
  });

  const { colorMode: currentTheme } = useColorMode();

  return (
    <PopoverRoot
      positioning={{
        placement: 'top-start',
        offset: { crossAxis: 0, mainAxis: 0 },
      }}
    >
      <PopoverTrigger
        onClick={() => {
          state[PICKER.BIG] ? toggleOpen(PICKER.BIG) : toggleOpen(PICKER.SMALL);
        }}
        data-testid="add-new-reaction-button"
        theme={theme ?? currentTheme}
      >
        <ReactionsPopoverButton
          isClicked={state[PICKER.SMALL] || state[PICKER.BIG]}
          theme={theme ?? currentTheme}
        />
      </PopoverTrigger>
      <PopoverContent portalled={false}>
        <PopoverBody p="0.25rem">
          {state[PICKER.BIG] ? (
            <EmojiPicker
              onEmojiSelect={({ native: emoji }) => {
                toggleOpen(PICKER.BIG);
                handleEmojiSelect(emoji);
              }}
              options={{ ...options, theme: currentTheme }}
            />
          ) : (
            <Flex>
              <ReactionsCommon
                emojis={emojis}
                onClick={(emoji) => {
                  toggleOpen(PICKER.SMALL);
                  handleEmojiSelect(emoji);
                }}
                toggleAll={toggleAll}
              />
            </Flex>
          )}
        </PopoverBody>
      </PopoverContent>
    </PopoverRoot>
  );
};
